import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { ImageInfo, ItemPersonRelation, MainItemBasic } from '@irohalab/mira-sdk-angular';

import { UIResponsiveImageWrapper } from '@irohalab/deneb-ui';
import { DEFAULT_IMAGE_INFO, imageRatio } from '../utils';

interface ItemWithRelation {
  name?: string;
  nameCn?: string;
  itemId: string | null | undefined;
  relationType: string | undefined;
  coverImage: ImageInfo;
  imageRatio: number;
}

@Component({
    selector: 'app-staff-list',
    imports: [
    UIResponsiveImageWrapper
],
    templateUrl: './staff-list.component.html',
    styleUrl: './staff-list.component.less'
})
export class StaffListComponent implements OnChanges {
  @Input()
  relatedMainItems!: MainItemBasic[];

  @Input()
  relations!: ItemPersonRelation[];

  relationTypeList: string[] = [];

  itemsWithRelationMap: {[key: string]: ItemWithRelation[]} = {};

  ngOnChanges(changes: SimpleChanges): void {
    this.initItemsWithRelation();
  }
  private initItemsWithRelation(): void {
    if (this.relations && this.relations.length > 0 && this.relatedMainItems && this.relatedMainItems.length > 0) {
      for (const relation of this.relations) {
        if (!this.itemsWithRelationMap[relation.relationType]) {
          this.itemsWithRelationMap[relation.relationType] = [];
        }
        const mainItem = this.relatedMainItems.find(item => item.id === relation.personItemId);
        if (mainItem) {
          let image = mainItem.coverImage;
          if (!image) {
            image = DEFAULT_IMAGE_INFO;
          }
          const itemWithRelation = {
            name: mainItem.name,
            nameCn: mainItem.nameCn,
            itemId: mainItem.id,
            relationType: relation.relationType,
            coverImage: image,
            imageRatio: imageRatio(image),
          };
          this.itemsWithRelationMap[relation.relationType].push(itemWithRelation);
        }
      }

      this.relationTypeList = Object.keys(this.itemsWithRelationMap);
    }
  }
}
